import { render, staticRenderFns } from "./ActionPlanResultsDays.vue?vue&type=template&id=4b98ed75&"
import script from "./ActionPlanResultsDays.vue?vue&type=script&lang=ts&"
export * from "./ActionPlanResultsDays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports